var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-3",attrs:{"icon":"","flat":"","color":"grey"},on:{"click":function($event){_vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("arrow_back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }